import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ErrorShowService } from '../services/error-show.service';
import { ForgotPasswordService } from '../services/forgot-password.service';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.scss'],
})
export class ForgotpasswordComponent implements OnInit {
  passwordForm: FormGroup;
  submitted = false;
  loading: boolean = false;
  loginWithOtp: boolean = false;
  phonenumber: string;

  constructor(
    private formBuilder: FormBuilder,
    private forgotPasswordService: ForgotPasswordService,
    private errorShowService: ErrorShowService,
    private router: Router
  ) {}

  ngOnInit() {
    this.errorShowService.SyncAndFlushData();
    this.passwordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  get f() {
    return this.passwordForm.controls;
  }
  onSubmit() {
    this.submitted = true;
    if (this.passwordForm.valid) {
      this.loading = true;
      this.forgotPasswordService
        .passwordResetService(this.passwordForm.value)
        .subscribe({
          next: (res) => {
            if (res['STATUS'] === 1) {
              this.loading = false;
              this.errorShowService.showSucess(res['MESSAGE']);
              this.router.navigate(['/']);

            } else {
              console.log(res);
              this.errorShowService.showError(res['MESSAGE']);
              this.loading = false;
            }
          },
          error: (err) => {
            this.errorShowService.showError(err['MESSAGE']);
            this.loading = false;
          },
        });
    }
  }
  onSubmitPhone() {
    var phoneToPass = "";
    if (this.phonenumber.charAt(0) == "+") {  //If number starts with + no change
      phoneToPass = encodeURIComponent(this.phonenumber)
    }
    else if (this.phonenumber.charAt(0) == "1") { //If number not + but starts with 1 only add +
      phoneToPass = encodeURIComponent("+" + this.phonenumber)
    }
    else if (this.phonenumber.length > 10) {
      phoneToPass = encodeURIComponent("+" + this.phonenumber)
    }
    else if (this.phonenumber.length == 10) {
      phoneToPass = encodeURIComponent("+" + "1" + this.phonenumber)
    }
    else {
      this.errorShowService.showError("Please enter valid phone number");
      this.loading = false;
      return ;
    }

    this.submitted = true;
      this.loading = true;
      this.forgotPasswordService
        .passwordMobileResetService(phoneToPass)
        .subscribe({
          next: (res) => {
            if (res['STATUS'] === 1) {
              this.loading = false;
              this.errorShowService.showSucess(res['MESSAGE']);
              this.router.navigate(['/']);

            } else {
              console.log(res);
              this.errorShowService.showError(res['MESSAGE']);
              this.loading = false;
            }
          },
          error: (err) => {
            this.errorShowService.showError(err['MESSAGE']);
            this.loading = false;
          },
        });
  }
  radioChange(e) {
    switch (e.target.value) {
      case "Email": {
        this.loginWithOtp = false;
        break;
      }
      case "Phone": {
        this.loginWithOtp = true;
        break;
      }
    }
  }
}
